"use client";

import React, { FC } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Typography from "@mui/material/Typography";

import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { COLOR_ADDITIONAL_VENETIAN_RED } from "~/theme/colors";
import { Error24 } from "~/theme/icons/components/error";

import { SHOPPING_LIST_POPUP_CLASSES } from "./constants";
import { ShoppingListPopupContainer } from "./styled";

export interface ShoppingListPopupProps {
  className?: string;
  open?: boolean;
  title?: string;
  description?: string;
  buttonText?: string;
  handlerClosePopup?: () => void;
}

export const ShoppingListPopup: FC<ShoppingListPopupProps> = ({
  title,
  description,
  buttonText,
  handlerClosePopup,
  open = false,
}) => {
  return (
    <ShoppingListPopupContainer open={open}>
      <Box className={SHOPPING_LIST_POPUP_CLASSES.popup}>
        <Box className={SHOPPING_LIST_POPUP_CLASSES.popupTitleWrap}>
          <Error24 htmlColor={COLOR_ADDITIONAL_VENETIAN_RED} />
          <Typography
            className={SHOPPING_LIST_POPUP_CLASSES.title}
            {...getTestAutomationProps("title-popup")}
          >
            {title}
          </Typography>
        </Box>
        <DialogContent className={SHOPPING_LIST_POPUP_CLASSES.descriptionWrap}>
          <DialogContentText
            className={SHOPPING_LIST_POPUP_CLASSES.description}
            {...getTestAutomationProps("description-popup")}
          >
            {description}
          </DialogContentText>
        </DialogContent>

        <DialogActions className={SHOPPING_LIST_POPUP_CLASSES.btnWrap}>
          <Button
            className={SHOPPING_LIST_POPUP_CLASSES.btn}
            onClick={handlerClosePopup}
          >
            {buttonText}
          </Button>
        </DialogActions>
      </Box>
    </ShoppingListPopupContainer>
  );
};
